import { ImagePathWithRenditions } from './ImageTypes';
import { UrlState } from './UrlTypes';

export type ContentTileListerOptions = {
  hideSearch: boolean;
  typeFilterOptions: number;
  typeFilterSortingOptions: number;
  categoryFilterOptions: number;
  categoryFilterSortingOptions: number;
  path?: string;
  tags?: [string];
  hideAllFilters: boolean;
  hiddenTags?: [string];
  filtersPath?: string;
  image?: ImagePathWithRenditions;
  hideTitle: boolean;
  overridePageTitle: string;
  overridableQuerystringParams?: UrlState;
};

export type ContentSearch = {
  totalElements: number;
  totalPages: number;
  size: number;
  content: Array<Content>;
};

export type Content = {
  _id?: number | null;
  title: string;
  image: string;
  responsiveImage?: string;
  type?: string;
  description: string;
  url: string;
  internalUrl: string;
  sortOrder: number;
  tags: Array<string>;
};

export type ContentType = {
  label: string;
  value: string;
};

export type ContentCategory = {
  label: string;
  value: string;
};
